import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/adquisiciones/devoluciones', documento: 'adquisiciones', acceso: 'sesion', filas: ['052'],
  cita: 'Areas/Adquisiciones/Controllers/DevolucionesController.cs',
} satisfies RutaProd;
